import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { ObsService } from '../../core/http/obs.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-obs',
  templateUrl: './obs.component.html',
  styleUrls: ['./obs.component.scss'],
})
export class ObsComponent implements OnInit {
  @ViewChild('name', { static: false }) ref: ElementRef;

  patient;
  FetchPatient;
  Patient_type: any = [];
  gender: any = [];
  AmnioticFluid: any = [];
  CervicalOs: any = [];
  Chorionicity: any = [];
  Amnionicity: any = [];
  Grade: any = [];
  PlacentaLocation: any = [];
  PlacentaLocationAnatomic: any = [];
  Presentation: any = [];
  FetalAnomaly: any = [];
  NoofFetus: any = [];
  TechnicalConditions: any = [];
  FetalHeartBeat: any = [];
  fetal_movement: any = [];
  fetalLie: any = [];
  image1: any = [];
  image2: any = [];
  templates: any = [];
  isPushing: boolean = false;
  buildLoad: boolean = false;
  freshLoad: boolean = false;
  resload: boolean = false;
  htmlStr;
  isSaveLoading;
  message;
  resultLoad: boolean = true;
  trimester;
  no_of_fetuss;
  PATIENT_NAME;
  REFERRED_BY;
  Patient_sex;
  PATIENT_AGE;
  PatientRefDr;
  patientTitle;
  date = new Date();
  fetuses = '';
  data;
  radiologist: any = [];
  drSign: any;
  NotifyDefaultRefDoctor = false;
  RefDoctorEmail = '';
  ResultHtmlBody = '';
  RefDoctorPhone = '';
  RefDoctorName = '';

  ftsingle_id;
  patient_id;
  referance_id;
  author_id;
  branch_code;
  sex;
  lmp;
  ga;
  edd;
  no_of_fetus;
  tech_condition;
  fetal_heart_beat;
  mean_gsd;
  crl;
  nt_thikness;
  amniotic_fluid;
  amnionicity;
  amniotic_fluids;
  p_location;
  us_average;
  uss_edd;
  us_edd;
  us_edds;
  genders;
  right_adnexium;
  left_adnexium;
  cervical_os;
  bpd;
  fl;
  ac;
  hc;
  efw;
  other_finding;
  comments;
  suggestion1;
  suggestion2;
  suggestion3;
  ftimage;
  fin_year;
  entry_date;
  update_entry_date;
  doctor_id;
  presentation;
  fetus_lie;
  fet_weg;
  P_location_ana;
  fet;
  fetus;
  a_fluid;
  bd_mm;
  bd_ga;
  fdl_mm;
  fdl_ga;
  ac_mm;
  ac_ga;
  hc_mm;
  hc_ga;
  g_age;
  exdd;
  finding;
  chorionicity;
  fetal_mment;
  conclusion1;
  conclusion2;
  conclusion3;

  ftsingle_id2;
  patient_id2;
  referance_id2;
  author_id2;
  branch_code2;
  sex2;
  lmp2;
  ga2;
  edd2;
  no_of_fetus2;
  tech_condition2;
  fetal_heart_beat2;
  mean_gsd2;
  crl2;
  nt_thikness2;
  amniotic_fluid2;
  amnionicity2;
  amniotic_fluids2;
  p_location2;
  us_average2;
  uss_edd2;
  us_edd2;
  us_edds2;
  genders2;
  right_adnexium2;
  left_adnexium2;
  cervical_os2;
  bpd2;
  fl2;
  ac2;
  hc2;
  efw2;
  other_finding2;
  comments2;
  suggestion12;
  suggestion22;
  suggestion32;
  ftimage2;
  fin_year2;
  entry_date2;
  update_entry_date2;
  doctor_id2;

  ftsingle_id3;
  patient_id3;
  referance_id3;
  author_id3;
  branch_code3;
  sex3;
  lmp3;
  ga3;
  edd3;
  no_of_fetus3;
  tech_condition3;
  fetal_heart_beat3;
  mean_gsd3;
  crl3;
  nt_thikness3;
  amniotic_fluid3;
  amnionicity3;
  amniotic_fluids3;
  p_location3;
  us_average3;
  uss_edd3;
  us_edd3;
  us_edds3;
  genders3;
  right_adnexium3;
  left_adnexium3;
  cervical_os3;
  bpd3;
  fl3;
  ac3;
  hc3;
  efw3;
  other_finding3;
  comments3;
  suggestion13;
  suggestion23;
  suggestion33;
  ftimage3;
  fin_year3;
  entry_date3;
  update_entry_date3;
  doctor_id3;

  head_shape_n;
  head_shape_ab;
  head_shape_nv;
  head_cavum_n;
  head_cavum_ab;
  head_cavum_nv;
  head_midline_n;
  head_midline_ab;
  head_midline_nv;
  head_thalami_n;
  head_thalami_ab;
  head_thalami_nv;
  head_lateral_n;
  head_lateral_ab;
  head_lateral_nv;
  head_cere_n;
  head_cere_ab;
  head_cere_nv;
  face_upp_n;
  face_upp_ab;
  face_upp_nv;
  face_orbit_n;
  face_orbit_ab;
  face_orbit_nv;
  face_nose_n;
  face_nose_ab;
  face_nose_nv;
  neck1;
  neck2;
  neck3;
  tho_shape_n;
  tho_shape_ab;
  tho_shape_nv;
  tho_mass_n;
  tho_mass_ab;
  tho_mass_nv;
  heart_activity_n;
  heart_activity_ab;
  heart_activity_nv;
  heart_size_n;
  heart_size_ab;
  heart_size_nv;
  heart_cadic_n;
  heart_cadic_ab;
  heart_cadic_nv;
  heart_chamber_n;
  heart_chamber_ab;
  heart_chamber_nv;
  abdo_dia_n;
  abdo_dia_ab;
  abdo_dia_nv;
  abdo_sto_n;
  abdo_sto_ab;
  abdo_sto_nv;
  abdo_bowel_n;
  abdo_bowel_ab;
  abdo_bowel_nv;
  abdo_kidney_n;
  abdo_kidney_ab;
  abdo_kidney_nv;
  abdo_unary_n;
  abdo_unary_ab;
  abdo_unary_nv;
  abdo_insert_n;
  abdo_insert_ab;
  abdo_insert_nv;
  abdo_vessel_n;
  abdo_vessel_ab;
  abdo_vessel_nv;
  spine1;
  spine2;
  spine3;
  limbs_ra_n;
  limbs_ra_ab;
  limbs_ra_nv;
  limbs_rl_n;
  limbs_rl_ab;
  limbs_rl_nv;
  limbs_la_n;
  limbs_la_ab;
  limbs_la_nv;
  limbs_ll_n;
  limbs_ll_ab;
  limbs_ll_nv;
  gender2;
  pushDisplay = false;
  isVisible = false;
  refVisible = false;
  doctorRef = '';
  docIsLoading = false;
  Errors = null;
  referred_doc;
  filteredDocs: any[] = [];

  constructor(
    private change: ChangeDetectorRef,
    public router: Router,
    private obs: ObsService,
    private sample: SampleService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService
  ) {}

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '600px',
    minHeight: '600px',
    maxHeight: '600px',
    width: 'auto',
    minWidth: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat'],
    ],
  };

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl('', Validators.required),
  });

  // done() {
  //   this.stateForm.patchValue({
  //     formatstr: this.htmlStr.replace(/"/g, '\'')
  //   });
  //   console.log(this.stateForm.value)
  //   this._snackBar.open('Template Added Successfully', '', {
  //     duration: 2000,
  //     verticalPosition: 'top',
  //   });
  // }

  ngOnInit(): void {
    this.sample.getRadiologist('radiologist').subscribe(
      (resSuccess: any) => {
        let data = resSuccess;
        this.radiologist = data[0];
        console.log(this.radiologist);
      },
      (resErr) => {}
    );
    this.obs.getDropdownValues(1).subscribe(
      (resSuccess) => {
        this.Patient_type = resSuccess;
      },
      (resErr) => {}
    );
    this.obs.getDropdownValues(33).subscribe(
      (resSuccess) => {
        this.fetalLie = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(30).subscribe(
      (resSuccess) => {
        this.fetal_movement = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(24).subscribe(
      (resSuccess) => {
        this.TechnicalConditions = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(25).subscribe(
      (resSuccess) => {
        this.FetalHeartBeat = resSuccess;
      },
      (resErr) => {}
    );
    this.obs.getDropdownValues(29).subscribe(
      (resSuccess) => {
        this.image1 = resSuccess;
      },
      (resErr) => {}
    );
    this.obs.getDropdownValues(28).subscribe(
      (resSuccess) => {
        this.image2 = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(23).subscribe(
      (resSuccess) => {
        this.NoofFetus = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(22).subscribe(
      (resSuccess) => {
        this.FetalAnomaly = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(21).subscribe(
      (resSuccess) => {
        this.Presentation = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(20).subscribe(
      (resSuccess) => {
        this.PlacentaLocationAnatomic = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(19).subscribe(
      (resSuccess) => {
        this.PlacentaLocation = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(18).subscribe(
      (resSuccess) => {
        this.Grade = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(17).subscribe(
      (resSuccess) => {
        this.Amnionicity = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(16).subscribe(
      (resSuccess) => {
        this.Chorionicity = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(15).subscribe(
      (resSuccess) => {
        this.CervicalOs = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(14).subscribe(
      (resSuccess) => {
        this.AmnioticFluid = resSuccess;
      },
      (resErr) => {}
    );

    this.obs.getDropdownValues(13).subscribe(
      (resSuccess) => {
        this.gender = resSuccess;
      },
      (resErr) => {}
    );

    this.patient = this.obs._patient;
    this.stateForm.patchValue({
      sample_id: this.patient.sample_id,
      format_code: this.patient.format_code,
      result_id: this.patient.result_id,
    });
    console.log(this.stateForm.value);

    this.obs.getPatient(this.patient.patient_id).subscribe(
      (resSuccess) => {
        this.FetchPatient = resSuccess[0];
        console.log('pat', this.FetchPatient);
        this.setting
          .getPatientById(this.FetchPatient.registration_no)
          .subscribe((resSuccess: any) => {
            let data = resSuccess;
            console.log('patient', data, data[0].ref_doct_code);
            this.setting
              .getRefDrById(data[0].ref_doct_code)
              .subscribe((resSuccess: any) => {
                let data = resSuccess;
                console.log('ref', data);
                this.RefDoctorEmail = data[0].email;
                this.RefDoctorName = data[0].ref_doctor_name;
                if (data[0].mobile[0] == '0') {
                  this.RefDoctorPhone =
                    '234' + data[0].mobile.substring(1).replace(/\s+/g, '');
                } else if (data[0].mobile[0] == '+') {
                  this.RefDoctorPhone = data[0].mobile
                    .substring(1)
                    .replace(/\s+/g, '');
                } else if (data[0].mobile.includes('234') == true) {
                  this.RefDoctorPhone = data[0].mobile.replace(/\s+/g, '');
                } else {
                  this.RefDoctorPhone =
                    '234' + data[0].mobile.replace(/\s+/g, '');
                }
              });
          });
      },
      (resErr) => {}
    );

    this.sample.getdetails(this.patient.result_id).subscribe(
      (resSuccess) => {
        this.templates = resSuccess;
        this.htmlStr = this.templates.data;
        console.log(this.templates);
      },
      (resErr) => {}
    );

    this.setting.getRefDr().subscribe(
      (resSuccess) => {
        this.referred_doc = resSuccess;
        console.log(this.referred_doc, 'Doctorrrrrrrrr');
        this.filteredDocs = this.referred_doc;
        this.docIsLoading = false;
      },
      (resErr) => {
        this.docIsLoading = false;
        this.Errors = resErr;
      }
    );
  }

  refVisibility() {
    this.refVisible = !this.refVisible;
  }

  addRefDoc(item) {
    console.log(item.Acount_Name);
    this.refVisible = !this.refVisible;
    this.doctorRef = item.Acount_Name;
    this.NotifyDefaultRefDoctor = true;
    this.RefDoctorName = item.Acount_Name;
    this.RefDoctorPhone = item.mobile;
    this.RefDoctorEmail = item.email;
  }

  pushOnlineObs() {
    let id = JSON.stringify([this.patient.result_id]);

    if (this.pushDisplay) {
      this.ResultHtmlBody = document.getElementById('dynamicContent').innerHTML;
      this.isPushing = true;
      this.sample
        .pushOnlineObs(
          this.patient.result_id,
          this.ResultHtmlBody,
          this.NotifyDefaultRefDoctor,
          '',
          '',
          ''
          // this.RefDoctorEmail,
          // this.RefDoctorPhone,
          // this.RefDoctorName
        )
        .subscribe(
          (resSuccess) => {
            this.message = resSuccess;
            this.isSaveLoading = false;
            console.log(resSuccess);
            this.isPushing = false;
            if (this.message.success) {
              this._snackBar.open('Sent Successfully', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
            } else {
              console.log('error');
              this._snackBar.open('Error Please Try Agian', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
            }
          },
          (resErr) => {
            this.isPushing = false;
            this.isSaveLoading = false;
            this._snackBar.open('error: please try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log(resErr);
          }
        );
    } else {
      this._snackBar.open('Fetch the report before you push', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    }
  }

  pushOnline() {
    let id = JSON.stringify([this.patient.result_id]);
    this.isPushing = true;
    this.sample
      .pushOnline(
        this.patient.result_id,
        '',
        '',
        id,
        this.NotifyDefaultRefDoctor,
        this.RefDoctorEmail,
        this.RefDoctorPhone,
        this.RefDoctorName
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);
          this.isPushing = false;
          if (this.message.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isPushing = false;
          this.isSaveLoading = false;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  refreshResult() {
    this.buildLoad = true;
    this.obs.getObsResult(this.patient.result_id).subscribe(
      (resSuccess) => {
        this.buildLoad = false;
        this.templates = resSuccess;
        console.log(this.templates);
        this.resultLoad = false;
        if (this.templates.success) {
          this.pushDisplay = true;
          this._snackBar.open('Result Fetch Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.trimester = this.templates.data.trimester;
          this.no_of_fetuss = this.templates.data.no_of_fetus;
          console.log(this.templates);

          if (this.templates.data.trimester == 1) {
            if (this.templates.data.no_of_fetus == 1) {
              this.ftsingle_id =
                this.templates.data.obj_model_01[0].token_value;
              this.patient_id = this.templates.data.obj_model_01[1].token_value;
              this.referance_id =
                this.templates.data.obj_model_01[2].token_value;
              this.author_id = this.templates.data.obj_model_01[3].token_value;
              this.branch_code =
                this.templates.data.obj_model_01[4].token_value;
              this.sex = this.templates.data.obj_model_01[5].token_value;
              this.lmp = this.templates.data.obj_model_01[6].token_value;
              this.ga = this.templates.data.obj_model_01[7].token_value;
              this.edd = this.templates.data.obj_model_01[8].token_value;
              this.no_of_fetus =
                this.templates.data.obj_model_01[9].token_value;
              this.tech_condition =
                this.templates.data.obj_model_01[10].token_value;
              this.fetal_heart_beat =
                this.templates.data.obj_model_01[11].token_value;
              this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
              this.crl = this.templates.data.obj_model_01[13].token_value;
              this.nt_thikness =
                this.templates.data.obj_model_01[14].token_value;
              this.amniotic_fluid =
                this.templates.data.obj_model_01[15].token_value;
              this.amnionicity =
                this.templates.data.obj_model_01[16].token_value;
              this.amniotic_fluids =
                this.templates.data.obj_model_01[17].token_value;
              this.p_location =
                this.templates.data.obj_model_01[18].token_value;
              this.us_average =
                this.templates.data.obj_model_01[19].token_value;
              this.uss_edd = this.templates.data.obj_model_01[20].token_value;
              this.us_edd = this.templates.data.obj_model_01[21].token_value;
              this.us_edds = this.templates.data.obj_model_01[22].token_value;
              this.genders = this.templates.data.obj_model_01[23].token_value;
              this.right_adnexium =
                this.templates.data.obj_model_01[24].token_value;
              this.left_adnexium =
                this.templates.data.obj_model_01[25].token_value;
              this.cervical_os =
                this.templates.data.obj_model_01[26].token_value;
              this.bpd = this.templates.data.obj_model_01[27].token_value;
              this.fl = this.templates.data.obj_model_01[28].token_value;
              this.ac = this.templates.data.obj_model_01[29].token_value;
              this.hc = this.templates.data.obj_model_01[30].token_value;
              this.efw = this.templates.data.obj_model_01[31].token_value;
              this.other_finding =
                this.templates.data.obj_model_01[32].token_value;
              this.comments = this.templates.data.obj_model_01[33].token_value;
              this.suggestion1 =
                this.templates.data.obj_model_01[34].token_value;
              this.suggestion2 =
                this.templates.data.obj_model_01[35].token_value;
              this.suggestion3 =
                this.templates.data.obj_model_01[36].token_value;
              this.ftimage = this.templates.data.obj_model_01[37].token_value;
              this.fin_year = this.templates.data.obj_model_01[38].token_value;
              this.entry_date =
                this.templates.data.obj_model_01[39].token_value;
              this.update_entry_date =
                this.templates.data.obj_model_01[40].token_value;
              this.trimester = this.templates.data.trimester;
              this.no_of_fetuss = this.templates.data.no_of_fetus;
              if (this.templates.data.obj_model_01[37].token_value) {
                this.change.detectChanges();
                this.ref.nativeElement.innerHTML =
                  this.templates.data.obj_model_01[37].token_value;
              }

              this.obs
                .getdr(this.templates.data.obj_model_01[41].token_value)
                .subscribe(
                  (resSuccess: any) => {
                    this.doctor_id = resSuccess[0].name;
                    console.log(resSuccess);
                    this.sample
                      .getRadiologist(resSuccess[0].email_no)
                      .subscribe(
                        (resSuccess: any) => {
                          let data = resSuccess;
                          this.drSign = data[0];
                          console.log(this.drSign);
                        },
                        (resErr) => {}
                      );
                  },
                  (resErr) => {}
                );
              this.obs
                .getSinglePatient(
                  this.templates.data.obj_model_01[1].token_value
                )
                .subscribe(
                  (resSuccess: any) => {
                    this.PATIENT_NAME = resSuccess[0].first_name;
                    this.PATIENT_AGE = resSuccess[0].age;
                    this.Patient_sex = resSuccess[0].sex;
                    console.log(resSuccess);
                  },
                  (resErr) => {}
                );
              this.obs
                .getRefDr(this.templates.data.obj_model_01[2].token_value)
                .subscribe(
                  (resSuccess: any) => {
                    this.PatientRefDr = resSuccess[0].Acount_Name;
                    console.log(resSuccess);
                  },
                  (resErr) => {}
                );
            } else if (this.templates.data.no_of_fetus == 2) {
              this.ftsingle_id =
                this.templates.data.obj_model_01[0].token_value;
              this.patient_id = this.templates.data.obj_model_01[1].token_value;
              this.referance_id =
                this.templates.data.obj_model_01[2].token_value;
              this.author_id = this.templates.data.obj_model_01[3].token_value;
              this.branch_code =
                this.templates.data.obj_model_01[5].token_value;
              this.sex = this.templates.data.obj_model_01[6].token_value;
              this.lmp = this.templates.data.obj_model_01[7].token_value;
              this.ga = this.templates.data.obj_model_01[8].token_value;
              this.edd = this.templates.data.obj_model_01[9].token_value;
              this.no_of_fetus =
                this.templates.data.obj_model_01[10].token_value;
              this.tech_condition =
                this.templates.data.obj_model_01[10].token_value;
              this.fetal_heart_beat =
                this.templates.data.obj_model_01[15].token_value;
              this.mean_gsd = this.templates.data.obj_model_01[16].token_value;
              this.crl = this.templates.data.obj_model_01[17].token_value;
              this.nt_thikness =
                this.templates.data.obj_model_01[18].token_value;
              this.amniotic_fluid =
                this.templates.data.obj_model_01[23].token_value;
              this.amnionicity =
                this.templates.data.obj_model_01[12].token_value;
              this.amniotic_fluids =
                this.templates.data.obj_model_01[12].token_value;
              this.p_location =
                this.templates.data.obj_model_01[26].token_value;
              this.us_average =
                this.templates.data.obj_model_01[28].token_value;
              this.uss_edd = this.templates.data.obj_model_01[31].token_value;
              this.us_edd = this.templates.data.obj_model_01[31].token_value;
              this.us_edds = this.templates.data.obj_model_01[31].token_value;
              this.genders = this.templates.data.obj_model_01[27].token_value;
              this.right_adnexium =
                this.templates.data.obj_model_01[32].token_value;
              this.left_adnexium =
                this.templates.data.obj_model_01[33].token_value;
              this.cervical_os =
                this.templates.data.obj_model_01[34].token_value;
              this.bpd = this.templates.data.obj_model_01[19].token_value;
              this.fl = this.templates.data.obj_model_01[20].token_value;
              this.ac = this.templates.data.obj_model_01[21].token_value;
              this.hc = this.templates.data.obj_model_01[22].token_value;
              this.efw = this.templates.data.obj_model_01[35].token_value;
              this.other_finding =
                this.templates.data.obj_model_01[36].token_value;
              this.comments = this.templates.data.obj_model_01[37].token_value;
              this.suggestion1 =
                this.templates.data.obj_model_01[38].token_value;
              this.suggestion2 =
                this.templates.data.obj_model_01[39].token_value;
              this.suggestion3 =
                this.templates.data.obj_model_01[40].token_value;
              this.ftimage = this.templates.data.obj_model_01[41].token_value;
              this.fin_year = this.templates.data.obj_model_01[42].token_value;
              this.entry_date =
                this.templates.data.obj_model_01[43].token_value;
              this.update_entry_date =
                this.templates.data.obj_model_01[44].token_value;
              this.trimester = this.templates.data.trimester;
              this.no_of_fetuss = this.templates.data.no_of_fetus;

              if (this.templates.data.obj_model_01[41].token_value) {
                this.change.detectChanges();
                this.ref.nativeElement.innerHTML =
                  this.templates.data.obj_model_01[41].token_value;
              }

              this.obs
                .getdr(this.templates.data.obj_model_01[45].token_value)
                .subscribe(
                  (resSuccess: any) => {
                    this.doctor_id = resSuccess[0].name;
                    this.sample
                      .getRadiologist(resSuccess[0].email_no)
                      .subscribe(
                        (resSuccess: any) => {
                          let data = resSuccess;
                          this.drSign = data[0];
                          console.log(this.drSign);
                        },
                        (resErr) => {}
                      );
                  },
                  (resErr) => {}
                );
              this.obs
                .getRefDr(this.templates.data.obj_model_01[2].token_value)
                .subscribe(
                  (resSuccess: any) => {
                    this.PatientRefDr = resSuccess[0].Acount_Name;
                    console.log(resSuccess);
                  },
                  (resErr) => {}
                );
              this.obs
                .getSinglePatient(
                  this.templates.data.obj_model_01[1].token_value
                )
                .subscribe(
                  (resSuccess: any) => {
                    this.PATIENT_NAME = resSuccess[0].first_name;
                    this.PATIENT_AGE = resSuccess[0].age;
                    this.Patient_sex = resSuccess[0].sex;
                    console.log(resSuccess);
                  },
                  (resErr) => {}
                );

              this.ftsingle_id2 =
                this.templates.data.obj_model_02[0].token_value;
              this.patient_id2 =
                this.templates.data.obj_model_02[1].token_value;
              this.referance_id2 =
                this.templates.data.obj_model_02[2].token_value;
              this.author_id2 = this.templates.data.obj_model_02[3].token_value;
              this.branch_code2 =
                this.templates.data.obj_model_02[5].token_value;
              this.sex2 = this.templates.data.obj_model_02[6].token_value;
              this.lmp2 = this.templates.data.obj_model_02[7].token_value;
              this.ga2 = this.templates.data.obj_model_02[8].token_value;
              this.edd2 = this.templates.data.obj_model_02[9].token_value;
              this.no_of_fetus2 =
                this.templates.data.obj_model_02[10].token_value;
              this.tech_condition2 =
                this.templates.data.obj_model_02[10].token_value;
              this.fetal_heart_beat2 =
                this.templates.data.obj_model_02[15].token_value;
              this.mean_gsd2 = this.templates.data.obj_model_02[16].token_value;
              this.crl2 = this.templates.data.obj_model_02[17].token_value;
              this.nt_thikness2 =
                this.templates.data.obj_model_02[18].token_value;
              this.amniotic_fluid2 =
                this.templates.data.obj_model_02[23].token_value;
              this.amnionicity2 =
                this.templates.data.obj_model_02[12].token_value;
              this.amniotic_fluids2 =
                this.templates.data.obj_model_02[12].token_value;
              this.p_location2 =
                this.templates.data.obj_model_02[26].token_value;
              this.us_average2 =
                this.templates.data.obj_model_02[28].token_value;
              this.uss_edd2 = this.templates.data.obj_model_02[31].token_value;
              this.us_edd2 = this.templates.data.obj_model_02[31].token_value;
              this.us_edds2 = this.templates.data.obj_model_02[31].token_value;
              this.genders2 = this.templates.data.obj_model_02[27].token_value;
              this.right_adnexium2 =
                this.templates.data.obj_model_02[32].token_value;
              this.left_adnexium2 =
                this.templates.data.obj_model_02[33].token_value;
              this.cervical_os2 =
                this.templates.data.obj_model_02[34].token_value;
              this.bpd2 = this.templates.data.obj_model_02[19].token_value;
              this.fl2 = this.templates.data.obj_model_02[20].token_value;
              this.ac2 = this.templates.data.obj_model_02[21].token_value;
              this.hc2 = this.templates.data.obj_model_02[22].token_value;
              this.efw2 = this.templates.data.obj_model_02[35].token_value;
              this.other_finding2 =
                this.templates.data.obj_model_02[36].token_value;
              this.comments2 = this.templates.data.obj_model_02[37].token_value;
              this.suggestion12 =
                this.templates.data.obj_model_02[38].token_value;
              this.suggestion22 =
                this.templates.data.obj_model_02[39].token_value;
              this.suggestion32 =
                this.templates.data.obj_model_02[40].token_value;
              this.ftimage2 = this.templates.data.obj_model_02[41].token_value;
              this.fin_year2 = this.templates.data.obj_model_02[42].token_value;
              this.entry_date2 =
                this.templates.data.obj_model_02[43].token_value;
              this.update_entry_date2 =
                this.templates.data.obj_model_02[44].token_value;
              this.trimester = this.templates.data.trimester;
              this.no_of_fetuss = this.templates.data.no_of_fetus;
              if (this.templates.data.obj_model_01[41].token_value) {
                this.change.detectChanges();
                this.ref.nativeElement.innerHTML =
                  this.templates.data.obj_model_01[41].token_value;
              }

              this.obs
                .getdr(this.templates.data.obj_model_01[45].token_value)
                .subscribe(
                  (resSuccess: any) => {
                    this.doctor_id = resSuccess[0].name;
                    this.sample
                      .getRadiologist(resSuccess[0].email_no)
                      .subscribe(
                        (resSuccess: any) => {
                          let data = resSuccess;
                          this.drSign = data[0];
                          console.log(this.drSign);
                        },
                        (resErr) => {}
                      );
                  },
                  (resErr) => {}
                );
              this.obs
                .getSinglePatient(
                  this.templates.data.obj_model_01[1].token_value
                )
                .subscribe(
                  (resSuccess: any) => {
                    this.PATIENT_NAME = resSuccess[0].first_name;
                    this.PATIENT_AGE = resSuccess[0].age;
                    this.Patient_sex = resSuccess[0].sex;
                    console.log(resSuccess);
                  },
                  (resErr) => {}
                );
              this.obs
                .getRefDr(this.templates.data.obj_model_01[2].token_value)
                .subscribe(
                  (resSuccess: any) => {
                    this.PatientRefDr = resSuccess[0].Acount_Name;
                    console.log(resSuccess);
                  },
                  (resErr) => {}
                );
            } else if (this.templates.data.no_of_fetus == 3) {
              this.ftsingle_id =
                this.templates.data.obj_model_01[0].token_value;
              this.patient_id = this.templates.data.obj_model_01[1].token_value;
              this.referance_id =
                this.templates.data.obj_model_01[2].token_value;
              this.author_id = this.templates.data.obj_model_01[3].token_value;
              this.branch_code =
                this.templates.data.obj_model_01[4].token_value;
              this.sex = this.templates.data.obj_model_01[5].token_value;
              this.lmp = this.templates.data.obj_model_01[6].token_value;
              this.ga = this.templates.data.obj_model_01[7].token_value;
              this.edd = this.templates.data.obj_model_01[8].token_value;
              this.no_of_fetus =
                this.templates.data.obj_model_01[9].token_value;
              this.tech_condition =
                this.templates.data.obj_model_01[10].token_value;
              this.fetal_heart_beat =
                this.templates.data.obj_model_01[14].token_value;
              this.mean_gsd = this.templates.data.obj_model_01[15].token_value;
              this.crl = this.templates.data.obj_model_01[16].token_value;
              this.nt_thikness =
                this.templates.data.obj_model_01[17].token_value;
              this.amniotic_fluid =
                this.templates.data.obj_model_01[13].token_value;
              this.amnionicity =
                this.templates.data.obj_model_01[12].token_value;
              this.amniotic_fluids =
                this.templates.data.obj_model_01[13].token_value;
              this.p_location =
                this.templates.data.obj_model_01[25].token_value;
              this.us_average =
                this.templates.data.obj_model_01[27].token_value;
              this.uss_edd = this.templates.data.obj_model_01[28].token_value;
              this.us_edd = this.templates.data.obj_model_01[28].token_value;
              this.us_edds = this.templates.data.obj_model_01[28].token_value;
              this.genders = this.templates.data.obj_model_01[26].token_value;
              this.right_adnexium =
                this.templates.data.obj_model_01[31].token_value;
              this.left_adnexium =
                this.templates.data.obj_model_01[32].token_value;
              this.cervical_os =
                this.templates.data.obj_model_01[33].token_value;
              this.bpd = this.templates.data.obj_model_01[18].token_value;
              this.fl = this.templates.data.obj_model_01[19].token_value;
              this.ac = this.templates.data.obj_model_01[20].token_value;
              this.hc = this.templates.data.obj_model_01[21].token_value;
              this.efw = this.templates.data.obj_model_01[34].token_value;
              this.other_finding =
                this.templates.data.obj_model_01[38].token_value;
              this.comments = this.templates.data.obj_model_01[39].token_value;
              this.suggestion1 =
                this.templates.data.obj_model_01[40].token_value;
              this.suggestion2 =
                this.templates.data.obj_model_01[41].token_value;
              this.suggestion3 =
                this.templates.data.obj_model_01[42].token_value;
              this.ftimage = this.templates.data.obj_model_01[43].token_value;
              this.fin_year = this.templates.data.obj_model_01[44].token_value;
              this.entry_date =
                this.templates.data.obj_model_01[45].token_value;
              this.update_entry_date =
                this.templates.data.obj_model_01[46].token_value;
              this.trimester = this.templates.data.trimester;
              this.no_of_fetuss = this.templates.data.no_of_fetus;
              if (this.templates.data.obj_model_01[43].token_value) {
                this.change.detectChanges();
                this.ref.nativeElement.innerHTML =
                  this.templates.data.obj_model_01[43].token_value;
              }

              this.ftsingle_id2 =
                this.templates.data.obj_model_02[0].token_value;
              this.patient_id2 =
                this.templates.data.obj_model_02[1].token_value;
              this.referance_id2 =
                this.templates.data.obj_model_02[2].token_value;
              this.author_id2 = this.templates.data.obj_model_02[3].token_value;
              this.branch_code2 =
                this.templates.data.obj_model_02[4].token_value;
              this.sex2 = this.templates.data.obj_model_02[5].token_value;
              this.lmp2 = this.templates.data.obj_model_02[6].token_value;
              this.ga2 = this.templates.data.obj_model_02[7].token_value;
              this.edd2 = this.templates.data.obj_model_02[8].token_value;
              this.no_of_fetus2 =
                this.templates.data.obj_model_02[9].token_value;
              this.tech_condition2 =
                this.templates.data.obj_model_02[10].token_value;
              this.fetal_heart_beat2 =
                this.templates.data.obj_model_02[14].token_value;
              this.mean_gsd2 = this.templates.data.obj_model_02[15].token_value;
              this.crl2 = this.templates.data.obj_model_02[16].token_value;
              this.nt_thikness2 =
                this.templates.data.obj_model_02[17].token_value;
              this.amniotic_fluid2 =
                this.templates.data.obj_model_02[13].token_value;
              this.amnionicity2 =
                this.templates.data.obj_model_02[12].token_value;
              this.amniotic_fluids2 =
                this.templates.data.obj_model_02[13].token_value;
              this.p_location2 =
                this.templates.data.obj_model_02[25].token_value;
              this.us_average2 =
                this.templates.data.obj_model_02[27].token_value;
              this.uss_edd2 = this.templates.data.obj_model_02[28].token_value;
              this.us_edd2 = this.templates.data.obj_model_02[28].token_value;
              this.us_edds2 = this.templates.data.obj_model_02[28].token_value;
              this.genders2 = this.templates.data.obj_model_02[26].token_value;
              this.right_adnexium2 =
                this.templates.data.obj_model_02[31].token_value;
              this.left_adnexium2 =
                this.templates.data.obj_model_02[32].token_value;
              this.cervical_os2 =
                this.templates.data.obj_model_02[33].token_value;
              this.bpd2 = this.templates.data.obj_model_02[18].token_value;
              this.fl2 = this.templates.data.obj_model_02[19].token_value;
              this.ac2 = this.templates.data.obj_model_02[20].token_value;
              this.hc2 = this.templates.data.obj_model_02[21].token_value;
              this.efw2 = this.templates.data.obj_model_02[34].token_value;
              this.other_finding2 =
                this.templates.data.obj_model_02[38].token_value;
              this.comments2 = this.templates.data.obj_model_02[39].token_value;
              this.suggestion12 =
                this.templates.data.obj_model_02[40].token_value;
              this.suggestion22 =
                this.templates.data.obj_model_02[41].token_value;
              this.suggestion32 =
                this.templates.data.obj_model_02[42].token_value;
              this.ftimage2 = this.templates.data.obj_model_02[43].token_value;
              this.fin_year2 = this.templates.data.obj_model_02[44].token_value;
              this.entry_date2 =
                this.templates.data.obj_model_02[45].token_value;
              this.update_entry_date2 =
                this.templates.data.obj_model_02[46].token_value;
              this.trimester = this.templates.data.trimester;
              this.no_of_fetuss = this.templates.data.no_of_fetus;

              this.ftsingle_id3 =
                this.templates.data.obj_model_03[0].token_value;
              this.patient_id3 =
                this.templates.data.obj_model_03[1].token_value;
              this.referance_id3 =
                this.templates.data.obj_model_03[2].token_value;
              this.author_id3 = this.templates.data.obj_model_03[3].token_value;
              this.branch_code3 =
                this.templates.data.obj_model_03[4].token_value;
              this.sex3 = this.templates.data.obj_model_03[5].token_value;
              this.lmp3 = this.templates.data.obj_model_03[6].token_value;
              this.ga3 = this.templates.data.obj_model_03[7].token_value;
              this.edd3 = this.templates.data.obj_model_03[8].token_value;
              this.no_of_fetus3 =
                this.templates.data.obj_model_03[9].token_value;
              this.tech_condition3 =
                this.templates.data.obj_model_03[10].token_value;
              this.fetal_heart_beat3 =
                this.templates.data.obj_model_03[14].token_value;
              this.mean_gsd3 = this.templates.data.obj_model_03[15].token_value;
              this.crl3 = this.templates.data.obj_model_03[16].token_value;
              this.nt_thikness3 =
                this.templates.data.obj_model_03[17].token_value;
              this.amniotic_fluid3 =
                this.templates.data.obj_model_03[13].token_value;
              this.amnionicity3 =
                this.templates.data.obj_model_03[12].token_value;
              this.amniotic_fluids3 =
                this.templates.data.obj_model_03[13].token_value;
              this.p_location3 =
                this.templates.data.obj_model_03[25].token_value;
              this.us_average3 =
                this.templates.data.obj_model_03[27].token_value;
              this.uss_edd3 = this.templates.data.obj_model_03[28].token_value;
              this.us_edd3 = this.templates.data.obj_model_03[28].token_value;
              this.us_edds3 = this.templates.data.obj_model_03[28].token_value;
              this.genders3 = this.templates.data.obj_model_03[26].token_value;
              this.right_adnexium3 =
                this.templates.data.obj_model_03[31].token_value;
              this.left_adnexium3 =
                this.templates.data.obj_model_03[32].token_value;
              this.cervical_os3 =
                this.templates.data.obj_model_03[33].token_value;
              this.bpd3 = this.templates.data.obj_model_03[18].token_value;
              this.fl3 = this.templates.data.obj_model_03[19].token_value;
              this.ac3 = this.templates.data.obj_model_03[20].token_value;
              this.hc3 = this.templates.data.obj_model_03[21].token_value;
              this.efw3 = this.templates.data.obj_model_03[34].token_value;
              this.other_finding3 =
                this.templates.data.obj_model_03[38].token_value;
              this.comments3 = this.templates.data.obj_model_03[39].token_value;
              this.suggestion13 =
                this.templates.data.obj_model_03[40].token_value;
              this.suggestion23 =
                this.templates.data.obj_model_03[41].token_value;
              this.suggestion33 =
                this.templates.data.obj_model_03[42].token_value;
              this.ftimage3 = this.templates.data.obj_model_03[43].token_value;
              this.fin_year3 = this.templates.data.obj_model_03[44].token_value;
              this.entry_date3 =
                this.templates.data.obj_model_03[45].token_value;
              this.update_entry_date3 =
                this.templates.data.obj_model_03[46].token_value;
              this.trimester = this.templates.data.trimester;
              this.no_of_fetuss = this.templates.data.no_of_fetus;

              if (this.templates.data.obj_model_01[43].token_value) {
                this.change.detectChanges();
                this.ref.nativeElement.innerHTML =
                  this.templates.data.obj_model_01[43].token_value;
              }
              this.obs
                .getdr(this.templates.data.obj_model_01[47].token_value)
                .subscribe(
                  (resSuccess: any) => {
                    this.doctor_id = resSuccess[0].name;
                    this.sample
                      .getRadiologist(resSuccess[0].email_no)
                      .subscribe(
                        (resSuccess: any) => {
                          let data = resSuccess;
                          this.drSign = data[0];
                          console.log(this.drSign);
                        },
                        (resErr) => {}
                      );
                  },
                  (resErr) => {}
                );
              this.obs
                .getSinglePatient(
                  this.templates.data.obj_model_01[1].token_value
                )
                .subscribe(
                  (resSuccess: any) => {
                    this.PATIENT_NAME = resSuccess[0].first_name;
                    this.PATIENT_AGE = resSuccess[0].age;
                    this.Patient_sex = resSuccess[0].sex;
                    console.log(resSuccess);
                  },
                  (resErr) => {}
                );
              this.obs
                .getRefDr(this.templates.data.obj_model_01[2].token_value)
                .subscribe(
                  (resSuccess: any) => {
                    this.PatientRefDr = resSuccess[0].Acount_Name;
                    console.log(resSuccess);
                  },
                  (resErr) => {}
                );
            }
          } else if (this.templates.data.trimester == 2) {
            this.ftsingle_id = this.templates.data.obj_model_01[0].token_value;
            this.patient_id = this.templates.data.obj_model_01[1].token_value;
            this.referance_id = this.templates.data.obj_model_01[2].token_value;
            this.author_id = this.templates.data.obj_model_01[3].token_value;
            this.branch_code = this.templates.data.obj_model_01[4].token_value;
            this.sex = this.templates.data.obj_model_01[5].token_value;
            this.lmp = this.templates.data.obj_model_01[6].token_value;
            this.ga = this.templates.data.obj_model_01[7].token_value;
            this.edd = this.templates.data.obj_model_01[8].token_value;
            this.no_of_fetus = this.templates.data.obj_model_01[10].token_value;
            this.tech_condition =
              this.templates.data.obj_model_01[9].token_value;
            this.fetal_heart_beat =
              this.templates.data.obj_model_01[10].token_value;
            this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
            this.crl = this.templates.data.obj_model_01[13].token_value;
            this.nt_thikness = this.templates.data.obj_model_01[14].token_value;
            this.amniotic_fluid =
              this.templates.data.obj_model_01[15].token_value;
            this.amnionicity = this.templates.data.obj_model_01[26].token_value;
            this.amniotic_fluids =
              this.templates.data.obj_model_01[25].token_value;
            this.p_location = this.templates.data.obj_model_01[12].token_value;
            this.us_average = this.templates.data.obj_model_01[19].token_value;
            this.uss_edd = this.templates.data.obj_model_01[20].token_value;
            this.us_edd = this.templates.data.obj_model_01[21].token_value;
            this.us_edds = this.templates.data.obj_model_01[22].token_value;
            this.genders = this.templates.data.obj_model_01[18].token_value;
            this.right_adnexium =
              this.templates.data.obj_model_01[24].token_value;
            this.left_adnexium =
              this.templates.data.obj_model_01[25].token_value;
            this.cervical_os = this.templates.data.obj_model_01[13].token_value;
            this.bpd = this.templates.data.obj_model_01[13].token_value;
            this.fl = this.templates.data.obj_model_01[14].token_value;
            this.ac = this.templates.data.obj_model_01[15].token_value;
            this.hc = this.templates.data.obj_model_01[16].token_value;
            this.efw = this.templates.data.obj_model_01[25].token_value;
            this.comments = this.templates.data.obj_model_01[30].token_value;
            this.ftimage = this.templates.data.obj_model_01[32].token_value;
            this.fin_year = this.templates.data.obj_model_01[33].token_value;
            this.entry_date = this.templates.data.obj_model_01[34].token_value;
            this.update_entry_date =
              this.templates.data.obj_model_01[35].token_value;
            this.presentation =
              this.templates.data.obj_model_01[11].token_value;
            this.fetus_lie = this.templates.data.obj_model_01[12].token_value;
            this.fet_weg = this.templates.data.obj_model_01[17].token_value;
            this.P_location_ana =
              this.templates.data.obj_model_01[23].token_value;
            this.fet = this.templates.data.obj_model_01[28].token_value;
            this.fetus = this.templates.data.obj_model_01[31].token_value;
            this.a_fluid = this.templates.data.obj_model_01[15].token_value;
            this.bd_mm = this.templates.data.obj_model_01[16].token_value;
            this.bd_ga = this.templates.data.obj_model_01[17].token_value;
            this.fdl_mm = this.templates.data.obj_model_01[18].token_value;
            this.fdl_ga = this.templates.data.obj_model_01[19].token_value;
            this.ac_mm = this.templates.data.obj_model_01[20].token_value;
            this.ac_ga = this.templates.data.obj_model_01[21].token_value;
            this.hc_mm = this.templates.data.obj_model_01[22].token_value;
            this.hc_ga = this.templates.data.obj_model_01[23].token_value;
            this.g_age = this.templates.data.obj_model_01[24].token_value;
            this.exdd = this.templates.data.obj_model_01[26].token_value;
            this.finding = this.templates.data.obj_model_01[27].token_value;
            this.chorionicity =
              this.templates.data.obj_model_01[11].token_value;
            this.fetal_mment = this.templates.data.obj_model_01[14].token_value;
            this.conclusion1 = this.templates.data.obj_model_01[28].token_value;
            this.conclusion2 = this.templates.data.obj_model_01[29].token_value;
            this.conclusion3 = this.templates.data.obj_model_01[30].token_value;

            this.head_shape_n = this.templates.data.obj_model_02[2].token_value;
            this.head_shape_ab =
              this.templates.data.obj_model_02[3].token_value;
            this.head_shape_nv =
              this.templates.data.obj_model_02[4].token_value;
            this.head_cavum_n = this.templates.data.obj_model_02[5].token_value;
            this.head_cavum_ab =
              this.templates.data.obj_model_02[6].token_value;
            this.head_cavum_nv =
              this.templates.data.obj_model_02[7].token_value;
            this.head_midline_n =
              this.templates.data.obj_model_02[8].token_value;
            this.head_midline_ab =
              this.templates.data.obj_model_02[9].token_value;
            this.head_midline_nv =
              this.templates.data.obj_model_02[10].token_value;
            this.head_thalami_n =
              this.templates.data.obj_model_02[11].token_value;
            this.head_thalami_ab =
              this.templates.data.obj_model_02[12].token_value;
            this.head_thalami_nv =
              this.templates.data.obj_model_02[13].token_value;
            this.head_lateral_n =
              this.templates.data.obj_model_02[14].token_value;
            this.head_lateral_ab =
              this.templates.data.obj_model_02[15].token_value;
            this.head_lateral_nv =
              this.templates.data.obj_model_02[16].token_value;
            this.head_cere_n = this.templates.data.obj_model_02[17].token_value;
            this.head_cere_ab =
              this.templates.data.obj_model_02[18].token_value;
            this.head_cere_nv =
              this.templates.data.obj_model_02[19].token_value;
            this.face_upp_n = this.templates.data.obj_model_02[20].token_value;
            this.face_upp_ab = this.templates.data.obj_model_02[21].token_value;
            this.face_upp_nv = this.templates.data.obj_model_02[22].token_value;
            this.face_orbit_n =
              this.templates.data.obj_model_02[23].token_value;
            this.face_orbit_ab =
              this.templates.data.obj_model_02[24].token_value;
            this.face_orbit_nv =
              this.templates.data.obj_model_02[25].token_value;
            this.face_nose_n = this.templates.data.obj_model_02[26].token_value;
            this.face_nose_ab =
              this.templates.data.obj_model_02[27].token_value;
            this.face_nose_nv =
              this.templates.data.obj_model_02[28].token_value;
            this.neck1 = this.templates.data.obj_model_02[29].token_value;
            this.neck2 = this.templates.data.obj_model_02[30].token_value;
            this.neck3 = this.templates.data.obj_model_02[31].token_value;
            this.tho_shape_n = this.templates.data.obj_model_02[32].token_value;
            this.tho_shape_ab =
              this.templates.data.obj_model_02[33].token_value;
            this.tho_shape_nv =
              this.templates.data.obj_model_02[34].token_value;
            this.tho_mass_n = this.templates.data.obj_model_02[35].token_value;
            this.tho_mass_ab = this.templates.data.obj_model_02[36].token_value;
            this.tho_mass_nv = this.templates.data.obj_model_02[37].token_value;
            this.heart_activity_n =
              this.templates.data.obj_model_02[38].token_value;
            this.heart_activity_ab =
              this.templates.data.obj_model_02[39].token_value;
            this.heart_activity_nv =
              this.templates.data.obj_model_02[40].token_value;
            this.heart_size_n =
              this.templates.data.obj_model_02[41].token_value;
            this.heart_size_ab =
              this.templates.data.obj_model_02[42].token_value;
            this.heart_size_nv =
              this.templates.data.obj_model_02[43].token_value;
            this.heart_cadic_n =
              this.templates.data.obj_model_02[44].token_value;
            this.heart_cadic_ab =
              this.templates.data.obj_model_02[45].token_value;
            this.heart_cadic_nv =
              this.templates.data.obj_model_02[46].token_value;
            this.heart_chamber_n =
              this.templates.data.obj_model_02[47].token_value;
            this.heart_chamber_ab =
              this.templates.data.obj_model_02[48].token_value;
            this.heart_chamber_nv =
              this.templates.data.obj_model_02[49].token_value;
            this.abdo_dia_n = this.templates.data.obj_model_02[50].token_value;
            this.abdo_dia_ab = this.templates.data.obj_model_02[51].token_value;
            this.abdo_dia_nv = this.templates.data.obj_model_02[52].token_value;
            this.abdo_sto_n = this.templates.data.obj_model_02[53].token_value;
            this.abdo_sto_ab = this.templates.data.obj_model_02[54].token_value;
            this.abdo_sto_nv = this.templates.data.obj_model_02[55].token_value;
            this.abdo_bowel_n =
              this.templates.data.obj_model_02[56].token_value;
            this.abdo_bowel_ab =
              this.templates.data.obj_model_02[57].token_value;
            this.abdo_bowel_nv =
              this.templates.data.obj_model_02[58].token_value;
            this.abdo_kidney_n =
              this.templates.data.obj_model_02[59].token_value;
            this.abdo_kidney_ab =
              this.templates.data.obj_model_02[60].token_value;
            this.abdo_kidney_nv =
              this.templates.data.obj_model_02[61].token_value;
            this.abdo_unary_n =
              this.templates.data.obj_model_02[62].token_value;
            this.abdo_unary_ab =
              this.templates.data.obj_model_02[63].token_value;
            this.abdo_unary_nv =
              this.templates.data.obj_model_02[64].token_value;
            this.abdo_insert_n =
              this.templates.data.obj_model_02[65].token_value;
            this.abdo_insert_ab =
              this.templates.data.obj_model_02[66].token_value;
            this.abdo_insert_nv =
              this.templates.data.obj_model_02[67].token_value;
            this.abdo_vessel_n =
              this.templates.data.obj_model_02[68].token_value;
            this.abdo_vessel_ab =
              this.templates.data.obj_model_02[69].token_value;
            this.abdo_vessel_nv =
              this.templates.data.obj_model_02[70].token_value;
            this.spine1 = this.templates.data.obj_model_02[71].token_value;
            this.spine2 = this.templates.data.obj_model_02[72].token_value;
            this.spine3 = this.templates.data.obj_model_02[73].token_value;
            this.limbs_ra_n = this.templates.data.obj_model_02[74].token_value;
            this.limbs_ra_ab = this.templates.data.obj_model_02[75].token_value;
            this.limbs_ra_nv = this.templates.data.obj_model_02[76].token_value;
            this.limbs_rl_n = this.templates.data.obj_model_02[77].token_value;
            this.limbs_rl_ab = this.templates.data.obj_model_02[78].token_value;
            this.limbs_rl_nv = this.templates.data.obj_model_02[79].token_value;
            this.limbs_la_n = this.templates.data.obj_model_02[80].token_value;
            this.limbs_la_ab = this.templates.data.obj_model_02[81].token_value;
            this.limbs_la_nv = this.templates.data.obj_model_02[82].token_value;
            this.limbs_ll_n = this.templates.data.obj_model_02[83].token_value;
            this.limbs_ll_ab = this.templates.data.obj_model_02[84].token_value;
            this.limbs_ll_nv = this.templates.data.obj_model_02[85].token_value;
            this.gender2 = this.templates.data.obj_model_02[86].token_value;
            this.trimester = this.templates.data.trimester;
            this.no_of_fetuss = this.templates.data.no_of_fetus;
            // if (this.templates.data.obj_model_01[32].token_value) {
            //   this.change.detectChanges();
            //   this.ref.nativeElement.innerHTML =
            //     this.templates.data.obj_model_01[32].token_value;
            // }

            this.obs
              .getdr(this.templates.data.obj_model_01[36].token_value)
              .subscribe(
                (resSuccess: any) => {
                  console.log('dr', resSuccess);
                  this.doctor_id = resSuccess[0].name;
                  this.sample.getRadiologist(resSuccess[0].email_no).subscribe(
                    (resSuccess: any) => {
                      let data = resSuccess;
                      this.drSign = data[0];
                      console.log(this.drSign);
                    },
                    (resErr) => {}
                  );
                },
                (resErr) => {}
              );
            // this.obs
            //   .getSinglePatient(this.templates.data.obj_model_01[1].token_value)
            //   .subscribe(
            //     (resSuccess: any) => {
            //       this.PATIENT_NAME = resSuccess[0].first_name;
            //       this.PATIENT_AGE = resSuccess[0].age;
            //       this.Patient_sex = resSuccess[0].sex;
            //       console.log(resSuccess);
            //       this.obs.getTitle(resSuccess[0].ref_doct_code).subscribe(
            //         (resSuccess: any) => {
            //           this.patientTitle = resSuccess.name;
            //         },
            //         (resErr) => {}
            //       );
            //     },
            //     (resErr) => {}
            //   );
            this.obs
              .getSinglePatient(this.templates.data.obj_model_01[1].token_value)
              .subscribe(
                (resSuccess: any) => {
                  this.PATIENT_NAME = resSuccess[0].first_name;
                  this.PATIENT_AGE = resSuccess[0].age;
                  this.Patient_sex = resSuccess[0].sex;
                  console.log(resSuccess);
                },
                (resErr) => {}
              );

            this.obs
              .getRefDr(this.templates.data.obj_model_01[2].token_value)
              .subscribe(
                (resSuccess: any) => {
                  this.PatientRefDr = resSuccess[0].Acount_Name;
                  console.log(resSuccess);
                },
                (resErr) => {}
              );
          } else if (this.templates.data.trimester == 3) {
            this.ftsingle_id = this.templates.data.obj_model_01[0].token_value;
            this.patient_id = this.templates.data.obj_model_01[1].token_value;
            this.referance_id = this.templates.data.obj_model_01[2].token_value;
            this.author_id = this.templates.data.obj_model_01[3].token_value;
            this.branch_code = this.templates.data.obj_model_01[4].token_value;
            this.sex = this.templates.data.obj_model_01[18].token_value;
            this.lmp = this.templates.data.obj_model_01[6].token_value;
            this.ga = this.templates.data.obj_model_01[7].token_value;
            this.edd = this.templates.data.obj_model_01[8].token_value;
            this.no_of_fetus = this.templates.data.obj_model_01[9].token_value;
            this.tech_condition =
              this.templates.data.obj_model_01[10].token_value;
            this.fetal_heart_beat =
              this.templates.data.obj_model_01[10].token_value;
            this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
            this.crl = this.templates.data.obj_model_01[13].token_value;
            this.nt_thikness = this.templates.data.obj_model_01[14].token_value;
            this.amniotic_fluid =
              this.templates.data.obj_model_01[15].token_value;
            this.amnionicity = this.templates.data.obj_model_01[26].token_value;
            this.amniotic_fluids =
              this.templates.data.obj_model_01[25].token_value;
            this.p_location = this.templates.data.obj_model_01[24].token_value;
            this.us_average = this.templates.data.obj_model_01[19].token_value;
            this.uss_edd = this.templates.data.obj_model_01[20].token_value;
            this.us_edd = this.templates.data.obj_model_01[21].token_value;
            this.us_edds = this.templates.data.obj_model_01[22].token_value;
            this.genders = this.templates.data.obj_model_01[18].token_value;
            this.right_adnexium =
              this.templates.data.obj_model_01[24].token_value;
            this.left_adnexium =
              this.templates.data.obj_model_01[25].token_value;
            this.cervical_os = this.templates.data.obj_model_01[29].token_value;
            this.bpd = this.templates.data.obj_model_01[13].token_value;
            this.fl = this.templates.data.obj_model_01[14].token_value;
            this.ac = this.templates.data.obj_model_01[15].token_value;
            this.hc = this.templates.data.obj_model_01[16].token_value;
            this.efw = this.templates.data.obj_model_01[31].token_value;
            this.comments = this.templates.data.obj_model_01[30].token_value;
            this.ftimage = this.templates.data.obj_model_01[32].token_value;
            this.fin_year = this.templates.data.obj_model_01[33].token_value;
            this.entry_date = this.templates.data.obj_model_01[34].token_value;
            this.update_entry_date =
              this.templates.data.obj_model_01[35].token_value;
            this.presentation =
              this.templates.data.obj_model_01[11].token_value;
            this.fetus_lie = this.templates.data.obj_model_01[12].token_value;
            this.fet_weg = this.templates.data.obj_model_01[17].token_value;
            this.P_location_ana =
              this.templates.data.obj_model_01[23].token_value;
            this.fet = this.templates.data.obj_model_01[28].token_value;
            this.fetus = this.templates.data.obj_model_01[31].token_value;
            this.trimester = this.templates.data.trimester;
            this.no_of_fetuss = this.templates.data.no_of_fetus;

            this.obs
              .getdr(this.templates.data.obj_model_01[36].token_value)
              .subscribe(
                (resSuccess: any) => {
                  this.doctor_id = resSuccess[0].name;
                  console.log('data is', resSuccess);

                  this.sample.getRadiologist(resSuccess[0].email_no).subscribe(
                    (resSuccess: any) => {
                      let data = resSuccess;
                      this.drSign = data[0];
                      console.log(this.drSign);
                    },
                    (resErr) => {}
                  );
                },
                (resErr) => {}
              );
            this.obs
              .getSinglePatient(this.templates.data.obj_model_01[1].token_value)
              .subscribe(
                (resSuccess: any) => {
                  this.PATIENT_NAME = resSuccess[0].first_name;
                  this.PATIENT_AGE = resSuccess[0].age;
                  this.Patient_sex = resSuccess[0].sex;
                  console.log(resSuccess);
                },
                (resErr) => {}
              );

            this.obs
              .getRefDr(this.templates.data.obj_model_01[2].token_value)
              .subscribe(
                (resSuccess: any) => {
                  this.PatientRefDr = resSuccess[0].Acount_Name;
                  console.log(resSuccess);
                },
                (resErr) => {}
              );

            if (this.templates.data.obj_model_01[32].token_value) {
              this.change.detectChanges();
              this.ref.nativeElement.innerHTML =
                this.templates.data.obj_model_01[32].token_value;
            }
          }
        } else {
          this._snackBar.open('Error: something went wrong', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.buildLoad = false;
        this._snackBar.open('Error Fetching Result', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }

  changeFetus(event) {
    if (this.fetuses == 'A') {
      if (this.templates.data.trimester == 3) {
        this.ftsingle_id = this.templates.data.obj_model_01[0].token_value;
        this.patient_id = this.templates.data.obj_model_01[1].token_value;
        this.referance_id = this.templates.data.obj_model_01[2].token_value;
        this.author_id = this.templates.data.obj_model_01[3].token_value;
        this.branch_code = this.templates.data.obj_model_01[4].token_value;
        this.sex = this.templates.data.obj_model_01[18].token_value;
        this.lmp = this.templates.data.obj_model_01[6].token_value;
        this.ga = this.templates.data.obj_model_01[7].token_value;
        this.edd = this.templates.data.obj_model_01[8].token_value;
        this.no_of_fetus = this.templates.data.obj_model_01[9].token_value;
        this.tech_condition = this.templates.data.obj_model_01[10].token_value;
        this.fetal_heart_beat =
          this.templates.data.obj_model_01[10].token_value;
        this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
        this.crl = this.templates.data.obj_model_01[13].token_value;
        this.nt_thikness = this.templates.data.obj_model_01[14].token_value;
        this.amniotic_fluid = this.templates.data.obj_model_01[15].token_value;
        this.amnionicity = this.templates.data.obj_model_01[26].token_value;
        this.amniotic_fluids = this.templates.data.obj_model_01[25].token_value;
        this.p_location = this.templates.data.obj_model_01[24].token_value;
        this.us_average = this.templates.data.obj_model_01[19].token_value;
        this.uss_edd = this.templates.data.obj_model_01[20].token_value;
        this.us_edd = this.templates.data.obj_model_01[21].token_value;
        this.us_edds = this.templates.data.obj_model_01[22].token_value;
        this.genders = this.templates.data.obj_model_01[18].token_value;
        this.right_adnexium = this.templates.data.obj_model_01[24].token_value;
        this.left_adnexium = this.templates.data.obj_model_01[25].token_value;
        this.cervical_os = this.templates.data.obj_model_01[29].token_value;
        this.bpd = this.templates.data.obj_model_01[13].token_value;
        this.fl = this.templates.data.obj_model_01[14].token_value;
        this.ac = this.templates.data.obj_model_01[15].token_value;
        this.hc = this.templates.data.obj_model_01[16].token_value;
        this.efw = this.templates.data.obj_model_01[31].token_value;
        this.comments = this.templates.data.obj_model_01[30].token_value;
        this.ftimage = this.templates.data.obj_model_01[32].token_value;
        this.fin_year = this.templates.data.obj_model_01[33].token_value;
        this.entry_date = this.templates.data.obj_model_01[34].token_value;
        this.update_entry_date =
          this.templates.data.obj_model_01[35].token_value;
        this.presentation = this.templates.data.obj_model_01[11].token_value;
        this.fetus_lie = this.templates.data.obj_model_01[12].token_value;
        this.fet_weg = this.templates.data.obj_model_01[17].token_value;
        this.P_location_ana = this.templates.data.obj_model_01[23].token_value;
        this.fet = this.templates.data.obj_model_01[28].token_value;
        this.fetus = this.templates.data.obj_model_01[31].token_value;
        this.trimester = this.templates.data.trimester;
        this.no_of_fetuss = this.templates.data.no_of_fetus;
      } else if (this.templates.data.trimester == 2) {
        this.ftsingle_id = this.templates.data.obj_model_01[0].token_value;
        this.patient_id = this.templates.data.obj_model_01[1].token_value;
        this.referance_id = this.templates.data.obj_model_01[2].token_value;
        this.author_id = this.templates.data.obj_model_01[3].token_value;
        this.branch_code = this.templates.data.obj_model_01[4].token_value;
        this.sex = this.templates.data.obj_model_01[5].token_value;
        this.lmp = this.templates.data.obj_model_01[6].token_value;
        this.ga = this.templates.data.obj_model_01[7].token_value;
        this.edd = this.templates.data.obj_model_01[8].token_value;
        this.no_of_fetus = this.templates.data.obj_model_01[10].token_value;
        this.tech_condition = this.templates.data.obj_model_01[9].token_value;
        this.fetal_heart_beat =
          this.templates.data.obj_model_01[10].token_value;
        this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
        this.crl = this.templates.data.obj_model_01[13].token_value;
        this.nt_thikness = this.templates.data.obj_model_01[14].token_value;
        this.amniotic_fluid = this.templates.data.obj_model_01[15].token_value;
        this.amnionicity = this.templates.data.obj_model_01[26].token_value;
        this.amniotic_fluids = this.templates.data.obj_model_01[25].token_value;
        this.p_location = this.templates.data.obj_model_01[12].token_value;
        this.us_average = this.templates.data.obj_model_01[19].token_value;
        this.uss_edd = this.templates.data.obj_model_01[20].token_value;
        this.us_edd = this.templates.data.obj_model_01[21].token_value;
        this.us_edds = this.templates.data.obj_model_01[22].token_value;
        this.genders = this.templates.data.obj_model_01[18].token_value;
        this.right_adnexium = this.templates.data.obj_model_01[24].token_value;
        this.left_adnexium = this.templates.data.obj_model_01[25].token_value;
        this.cervical_os = this.templates.data.obj_model_01[13].token_value;
        this.bpd = this.templates.data.obj_model_01[13].token_value;
        this.fl = this.templates.data.obj_model_01[14].token_value;
        this.ac = this.templates.data.obj_model_01[15].token_value;
        this.hc = this.templates.data.obj_model_01[16].token_value;
        this.efw = this.templates.data.obj_model_01[25].token_value;
        this.comments = this.templates.data.obj_model_01[27].token_value;
        this.ftimage = this.templates.data.obj_model_01[32].token_value;
        this.fin_year = this.templates.data.obj_model_01[33].token_value;
        this.entry_date = this.templates.data.obj_model_01[34].token_value;
        this.update_entry_date =
          this.templates.data.obj_model_01[35].token_value;
        this.presentation = this.templates.data.obj_model_01[11].token_value;
        this.fetus_lie = this.templates.data.obj_model_01[12].token_value;
        this.fet_weg = this.templates.data.obj_model_01[17].token_value;
        this.P_location_ana = this.templates.data.obj_model_01[23].token_value;
        this.fet = this.templates.data.obj_model_01[28].token_value;
        this.fetus = this.templates.data.obj_model_01[31].token_value;
        this.a_fluid = this.templates.data.obj_model_01[15].token_value;
        this.bd_mm = this.templates.data.obj_model_01[16].token_value;
        this.bd_ga = this.templates.data.obj_model_01[17].token_value;
        this.fdl_mm = this.templates.data.obj_model_01[18].token_value;
        this.fdl_ga = this.templates.data.obj_model_01[19].token_value;
        this.ac_mm = this.templates.data.obj_model_01[20].token_value;
        this.ac_ga = this.templates.data.obj_model_01[21].token_value;
        this.hc_mm = this.templates.data.obj_model_01[22].token_value;
        this.hc_ga = this.templates.data.obj_model_01[23].token_value;
        this.g_age = this.templates.data.obj_model_01[24].token_value;
        this.exdd = this.templates.data.obj_model_01[26].token_value;
        this.finding = this.templates.data.obj_model_01[27].token_value;
        this.chorionicity = this.templates.data.obj_model_01[11].token_value;
        this.fetal_mment = this.templates.data.obj_model_01[14].token_value;
        this.conclusion1 = this.templates.data.obj_model_01[28].token_value;
        this.conclusion2 = this.templates.data.obj_model_01[29].token_value;
        this.conclusion3 = this.templates.data.obj_model_01[30].token_value;

        this.head_shape_n = this.templates.data.obj_model_02[2].token_value;
        this.head_shape_ab = this.templates.data.obj_model_02[3].token_value;
        this.head_shape_nv = this.templates.data.obj_model_02[4].token_value;
        this.head_cavum_n = this.templates.data.obj_model_02[5].token_value;
        this.head_cavum_ab = this.templates.data.obj_model_02[6].token_value;
        this.head_cavum_nv = this.templates.data.obj_model_02[7].token_value;
        this.head_midline_n = this.templates.data.obj_model_02[8].token_value;
        this.head_midline_ab = this.templates.data.obj_model_02[9].token_value;
        this.head_midline_nv = this.templates.data.obj_model_02[10].token_value;
        this.head_thalami_n = this.templates.data.obj_model_02[11].token_value;
        this.head_thalami_ab = this.templates.data.obj_model_02[12].token_value;
        this.head_thalami_nv = this.templates.data.obj_model_02[13].token_value;
        this.head_lateral_n = this.templates.data.obj_model_02[14].token_value;
        this.head_lateral_ab = this.templates.data.obj_model_02[15].token_value;
        this.head_lateral_nv = this.templates.data.obj_model_02[16].token_value;
        this.head_cere_n = this.templates.data.obj_model_02[17].token_value;
        this.head_cere_ab = this.templates.data.obj_model_02[18].token_value;
        this.head_cere_nv = this.templates.data.obj_model_02[19].token_value;
        this.face_upp_n = this.templates.data.obj_model_02[20].token_value;
        this.face_upp_ab = this.templates.data.obj_model_02[21].token_value;
        this.face_upp_nv = this.templates.data.obj_model_02[22].token_value;
        this.face_orbit_n = this.templates.data.obj_model_02[23].token_value;
        this.face_orbit_ab = this.templates.data.obj_model_02[24].token_value;
        this.face_orbit_nv = this.templates.data.obj_model_02[25].token_value;
        this.face_nose_n = this.templates.data.obj_model_02[26].token_value;
        this.face_nose_ab = this.templates.data.obj_model_02[27].token_value;
        this.face_nose_nv = this.templates.data.obj_model_02[28].token_value;
        this.neck1 = this.templates.data.obj_model_02[29].token_value;
        this.neck2 = this.templates.data.obj_model_02[30].token_value;
        this.neck3 = this.templates.data.obj_model_02[31].token_value;
        this.tho_shape_n = this.templates.data.obj_model_02[32].token_value;
        this.tho_shape_ab = this.templates.data.obj_model_02[33].token_value;
        this.tho_shape_nv = this.templates.data.obj_model_02[34].token_value;
        this.tho_mass_n = this.templates.data.obj_model_02[35].token_value;
        this.tho_mass_ab = this.templates.data.obj_model_02[36].token_value;
        this.tho_mass_nv = this.templates.data.obj_model_02[37].token_value;
        this.heart_activity_n =
          this.templates.data.obj_model_02[38].token_value;
        this.heart_activity_ab =
          this.templates.data.obj_model_02[39].token_value;
        this.heart_activity_nv =
          this.templates.data.obj_model_02[40].token_value;
        this.heart_size_n = this.templates.data.obj_model_02[41].token_value;
        this.heart_size_ab = this.templates.data.obj_model_02[42].token_value;
        this.heart_size_nv = this.templates.data.obj_model_02[43].token_value;
        this.heart_cadic_n = this.templates.data.obj_model_02[44].token_value;
        this.heart_cadic_ab = this.templates.data.obj_model_02[45].token_value;
        this.heart_cadic_nv = this.templates.data.obj_model_02[46].token_value;
        this.heart_chamber_n = this.templates.data.obj_model_02[47].token_value;
        this.heart_chamber_ab =
          this.templates.data.obj_model_02[48].token_value;
        this.heart_chamber_nv =
          this.templates.data.obj_model_02[49].token_value;
        this.abdo_dia_n = this.templates.data.obj_model_02[50].token_value;
        this.abdo_dia_ab = this.templates.data.obj_model_02[51].token_value;
        this.abdo_dia_nv = this.templates.data.obj_model_02[52].token_value;
        this.abdo_sto_n = this.templates.data.obj_model_02[53].token_value;
        this.abdo_sto_ab = this.templates.data.obj_model_02[54].token_value;
        this.abdo_sto_nv = this.templates.data.obj_model_02[55].token_value;
        this.abdo_bowel_n = this.templates.data.obj_model_02[56].token_value;
        this.abdo_bowel_ab = this.templates.data.obj_model_02[57].token_value;
        this.abdo_bowel_nv = this.templates.data.obj_model_02[58].token_value;
        this.abdo_kidney_n = this.templates.data.obj_model_02[59].token_value;
        this.abdo_kidney_ab = this.templates.data.obj_model_02[60].token_value;
        this.abdo_kidney_nv = this.templates.data.obj_model_02[61].token_value;
        this.abdo_unary_n = this.templates.data.obj_model_02[62].token_value;
        this.abdo_unary_ab = this.templates.data.obj_model_02[63].token_value;
        this.abdo_unary_nv = this.templates.data.obj_model_02[64].token_value;
        this.abdo_insert_n = this.templates.data.obj_model_02[65].token_value;
        this.abdo_insert_ab = this.templates.data.obj_model_02[66].token_value;
        this.abdo_insert_nv = this.templates.data.obj_model_02[67].token_value;
        this.abdo_vessel_n = this.templates.data.obj_model_02[68].token_value;
        this.abdo_vessel_ab = this.templates.data.obj_model_02[69].token_value;
        this.abdo_vessel_nv = this.templates.data.obj_model_02[70].token_value;
        this.spine1 = this.templates.data.obj_model_02[71].token_value;
        this.spine2 = this.templates.data.obj_model_02[72].token_value;
        this.spine3 = this.templates.data.obj_model_02[73].token_value;
        this.limbs_ra_n = this.templates.data.obj_model_02[74].token_value;
        this.limbs_ra_ab = this.templates.data.obj_model_02[75].token_value;
        this.limbs_ra_nv = this.templates.data.obj_model_02[76].token_value;
        this.limbs_rl_n = this.templates.data.obj_model_02[77].token_value;
        this.limbs_rl_ab = this.templates.data.obj_model_02[78].token_value;
        this.limbs_rl_nv = this.templates.data.obj_model_02[79].token_value;
        this.limbs_la_n = this.templates.data.obj_model_02[80].token_value;
        this.limbs_la_ab = this.templates.data.obj_model_02[81].token_value;
        this.limbs_la_nv = this.templates.data.obj_model_02[82].token_value;
        this.limbs_ll_n = this.templates.data.obj_model_02[83].token_value;
        this.limbs_ll_ab = this.templates.data.obj_model_02[84].token_value;
        this.limbs_ll_nv = this.templates.data.obj_model_02[85].token_value;
        this.gender2 = this.templates.data.obj_model_02[86].token_value;
        this.trimester = this.templates.data.trimester;
        this.no_of_fetuss = this.templates.data.no_of_fetus;
      }
    } else if (this.fetuses == 'B') {
      if (this.templates.data.trimester == 3) {
        this.ftsingle_id = this.templates.data.obj_model_01[37].token_value;
        this.patient_id = this.templates.data.obj_model_01[38].token_value;
        this.referance_id = this.templates.data.obj_model_01[39].token_value;
        this.author_id = this.templates.data.obj_model_01[40].token_value;
        this.branch_code = this.templates.data.obj_model_01[41].token_value;
        this.sex = this.templates.data.obj_model_01[55].token_value;
        this.lmp = this.templates.data.obj_model_01[43].token_value;
        this.ga = this.templates.data.obj_model_01[44].token_value;
        this.edd = this.templates.data.obj_model_01[45].token_value;
        this.no_of_fetus = this.templates.data.obj_model_01[46].token_value;
        this.tech_condition = this.templates.data.obj_model_01[10].token_value;
        this.fetal_heart_beat =
          this.templates.data.obj_model_01[47].token_value;
        this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
        this.crl = this.templates.data.obj_model_01[13].token_value;
        this.nt_thikness = this.templates.data.obj_model_01[14].token_value;
        this.amniotic_fluid = this.templates.data.obj_model_01[64].token_value;
        this.amnionicity = this.templates.data.obj_model_01[63].token_value;
        this.amniotic_fluids = this.templates.data.obj_model_01[64].token_value;
        this.p_location = this.templates.data.obj_model_01[61].token_value;
        this.us_average = this.templates.data.obj_model_01[56].token_value;
        this.uss_edd = this.templates.data.obj_model_01[58].token_value;
        this.us_edd = this.templates.data.obj_model_01[58].token_value;
        this.us_edds = this.templates.data.obj_model_01[58].token_value;
        this.genders = this.templates.data.obj_model_01[55].token_value;
        this.right_adnexium = this.templates.data.obj_model_01[24].token_value;
        this.left_adnexium = this.templates.data.obj_model_01[25].token_value;
        this.cervical_os = this.templates.data.obj_model_01[66].token_value;
        this.bpd = this.templates.data.obj_model_01[50].token_value;
        this.fl = this.templates.data.obj_model_01[51].token_value;
        this.ac = this.templates.data.obj_model_01[52].token_value;
        this.hc = this.templates.data.obj_model_01[53].token_value;
        this.efw = this.templates.data.obj_model_01[31].token_value;
        this.comments = this.templates.data.obj_model_01[67].token_value;
        this.ftimage = this.templates.data.obj_model_01[69].token_value;
        this.fin_year = this.templates.data.obj_model_01[70].token_value;
        this.entry_date = this.templates.data.obj_model_01[71].token_value;
        this.update_entry_date =
          this.templates.data.obj_model_01[72].token_value;
        this.presentation = this.templates.data.obj_model_01[48].token_value;
        this.fetus_lie = this.templates.data.obj_model_01[49].token_value;
        this.fet_weg = this.templates.data.obj_model_01[54].token_value;
        this.P_location_ana = this.templates.data.obj_model_01[60].token_value;
        this.fet = this.templates.data.obj_model_01[65].token_value;
        this.fetus = this.templates.data.obj_model_01[68].token_value;
        this.trimester = this.templates.data.trimester;
        this.no_of_fetuss = this.templates.data.no_of_fetus;
      } else if (this.templates.data.trimester == 2) {
        this.ftsingle_id = this.templates.data.obj_model_01[37].token_value;
        this.patient_id = this.templates.data.obj_model_01[38].token_value;
        this.referance_id = this.templates.data.obj_model_01[39].token_value;
        this.author_id = this.templates.data.obj_model_01[40].token_value;
        this.branch_code = this.templates.data.obj_model_01[41].token_value;
        this.sex = this.templates.data.obj_model_01[42].token_value;
        this.lmp = this.templates.data.obj_model_01[43].token_value;
        this.ga = this.templates.data.obj_model_01[44].token_value;
        this.edd = this.templates.data.obj_model_01[45].token_value;
        this.no_of_fetus = this.templates.data.obj_model_01[47].token_value;
        this.tech_condition = this.templates.data.obj_model_01[46].token_value;
        this.fetal_heart_beat =
          this.templates.data.obj_model_01[10].token_value;
        this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
        this.crl = this.templates.data.obj_model_01[13].token_value;
        this.nt_thikness = this.templates.data.obj_model_01[14].token_value;
        this.amniotic_fluid = this.templates.data.obj_model_01[52].token_value;
        this.amnionicity = this.templates.data.obj_model_01[26].token_value;
        this.amniotic_fluids = this.templates.data.obj_model_01[52].token_value;
        this.p_location = this.templates.data.obj_model_01[49].token_value;
        this.us_average = this.templates.data.obj_model_01[19].token_value;
        this.uss_edd = this.templates.data.obj_model_01[20].token_value;
        this.us_edd = this.templates.data.obj_model_01[21].token_value;
        this.us_edds = this.templates.data.obj_model_01[22].token_value;
        this.genders = this.templates.data.obj_model_01[42].token_value;
        this.right_adnexium = this.templates.data.obj_model_01[24].token_value;
        this.left_adnexium = this.templates.data.obj_model_01[25].token_value;
        this.cervical_os = this.templates.data.obj_model_01[50].token_value;
        this.bpd = this.templates.data.obj_model_01[13].token_value;
        this.fl = this.templates.data.obj_model_01[14].token_value;
        this.ac = this.templates.data.obj_model_01[15].token_value;
        this.hc = this.templates.data.obj_model_01[16].token_value;
        this.efw = this.templates.data.obj_model_01[62].token_value;
        this.comments = this.templates.data.obj_model_01[64].token_value;
        this.ftimage = this.templates.data.obj_model_01[69].token_value;
        this.fin_year = this.templates.data.obj_model_01[70].token_value;
        this.entry_date = this.templates.data.obj_model_01[71].token_value;
        this.update_entry_date =
          this.templates.data.obj_model_01[72].token_value;
        this.presentation = this.templates.data.obj_model_01[11].token_value;
        this.fetus_lie = this.templates.data.obj_model_01[12].token_value;
        this.fet_weg = this.templates.data.obj_model_01[17].token_value;
        this.P_location_ana = this.templates.data.obj_model_01[23].token_value;
        this.fet = this.templates.data.obj_model_01[28].token_value;
        this.fetus = this.templates.data.obj_model_01[31].token_value;
        this.a_fluid = this.templates.data.obj_model_01[52].token_value;
        this.bd_mm = this.templates.data.obj_model_01[53].token_value;
        this.bd_ga = this.templates.data.obj_model_01[54].token_value;
        this.fdl_mm = this.templates.data.obj_model_01[55].token_value;
        this.fdl_ga = this.templates.data.obj_model_01[56].token_value;
        this.ac_mm = this.templates.data.obj_model_01[57].token_value;
        this.ac_ga = this.templates.data.obj_model_01[58].token_value;
        this.hc_mm = this.templates.data.obj_model_01[59].token_value;
        this.hc_ga = this.templates.data.obj_model_01[60].token_value;
        this.g_age = this.templates.data.obj_model_01[61].token_value;
        this.exdd = this.templates.data.obj_model_01[63].token_value;
        this.finding = this.templates.data.obj_model_01[64].token_value;
        this.chorionicity = this.templates.data.obj_model_01[48].token_value;
        this.fetal_mment = this.templates.data.obj_model_01[51].token_value;
        this.conclusion1 = this.templates.data.obj_model_01[65].token_value;
        this.conclusion2 = this.templates.data.obj_model_01[66].token_value;
        this.conclusion3 = this.templates.data.obj_model_01[67].token_value;

        this.head_shape_n = this.templates.data.obj_model_02[89].token_value;
        this.head_shape_ab = this.templates.data.obj_model_02[90].token_value;
        this.head_shape_nv = this.templates.data.obj_model_02[91].token_value;
        this.head_cavum_n = this.templates.data.obj_model_02[92].token_value;
        this.head_cavum_ab = this.templates.data.obj_model_02[93].token_value;
        this.head_cavum_nv = this.templates.data.obj_model_02[94].token_value;
        this.head_midline_n = this.templates.data.obj_model_02[95].token_value;
        this.head_midline_ab = this.templates.data.obj_model_02[96].token_value;
        this.head_midline_nv = this.templates.data.obj_model_02[97].token_value;
        this.head_thalami_n = this.templates.data.obj_model_02[98].token_value;
        this.head_thalami_ab = this.templates.data.obj_model_02[99].token_value;
        this.head_thalami_nv =
          this.templates.data.obj_model_02[100].token_value;
        this.head_lateral_n = this.templates.data.obj_model_02[101].token_value;
        this.head_lateral_ab =
          this.templates.data.obj_model_02[102].token_value;
        this.head_lateral_nv =
          this.templates.data.obj_model_02[103].token_value;
        this.head_cere_n = this.templates.data.obj_model_02[104].token_value;
        this.head_cere_ab = this.templates.data.obj_model_02[105].token_value;
        this.head_cere_nv = this.templates.data.obj_model_02[106].token_value;
        this.face_upp_n = this.templates.data.obj_model_02[107].token_value;
        this.face_upp_ab = this.templates.data.obj_model_02[108].token_value;
        this.face_upp_nv = this.templates.data.obj_model_02[109].token_value;
        this.face_orbit_n = this.templates.data.obj_model_02[110].token_value;
        this.face_orbit_ab = this.templates.data.obj_model_02[111].token_value;
        this.face_orbit_nv = this.templates.data.obj_model_02[112].token_value;
        this.face_nose_n = this.templates.data.obj_model_02[113].token_value;
        this.face_nose_ab = this.templates.data.obj_model_02[114].token_value;
        this.face_nose_nv = this.templates.data.obj_model_02[114].token_value;
        this.neck1 = this.templates.data.obj_model_02[116].token_value;
        this.neck2 = this.templates.data.obj_model_02[117].token_value;
        this.neck3 = this.templates.data.obj_model_02[118].token_value;
        this.tho_shape_n = this.templates.data.obj_model_02[119].token_value;
        this.tho_shape_ab = this.templates.data.obj_model_02[120].token_value;
        this.tho_shape_nv = this.templates.data.obj_model_02[121].token_value;
        this.tho_mass_n = this.templates.data.obj_model_02[122].token_value;
        this.tho_mass_ab = this.templates.data.obj_model_02[123].token_value;
        this.tho_mass_nv = this.templates.data.obj_model_02[124].token_value;
        this.heart_activity_n =
          this.templates.data.obj_model_02[125].token_value;
        this.heart_activity_ab =
          this.templates.data.obj_model_02[126].token_value;
        this.heart_activity_nv =
          this.templates.data.obj_model_02[127].token_value;
        this.heart_size_n = this.templates.data.obj_model_02[128].token_value;
        this.heart_size_ab = this.templates.data.obj_model_02[129].token_value;
        this.heart_size_nv = this.templates.data.obj_model_02[130].token_value;
        this.heart_cadic_n = this.templates.data.obj_model_02[131].token_value;
        this.heart_cadic_ab = this.templates.data.obj_model_02[132].token_value;
        this.heart_cadic_nv = this.templates.data.obj_model_02[133].token_value;
        this.heart_chamber_n =
          this.templates.data.obj_model_02[134].token_value;
        this.heart_chamber_ab =
          this.templates.data.obj_model_02[135].token_value;
        this.heart_chamber_nv =
          this.templates.data.obj_model_02[136].token_value;
        this.abdo_dia_n = this.templates.data.obj_model_02[137].token_value;
        this.abdo_dia_ab = this.templates.data.obj_model_02[138].token_value;
        this.abdo_dia_nv = this.templates.data.obj_model_02[138].token_value;
        this.abdo_sto_n = this.templates.data.obj_model_02[140].token_value;
        this.abdo_sto_ab = this.templates.data.obj_model_02[141].token_value;
        this.abdo_sto_nv = this.templates.data.obj_model_02[142].token_value;
        this.abdo_bowel_n = this.templates.data.obj_model_02[143].token_value;
        this.abdo_bowel_ab = this.templates.data.obj_model_02[144].token_value;
        this.abdo_bowel_nv = this.templates.data.obj_model_02[145].token_value;
        this.abdo_kidney_n = this.templates.data.obj_model_02[146].token_value;
        this.abdo_kidney_ab = this.templates.data.obj_model_02[147].token_value;
        this.abdo_kidney_nv = this.templates.data.obj_model_02[148].token_value;
        this.abdo_unary_n = this.templates.data.obj_model_02[149].token_value;
        this.abdo_unary_ab = this.templates.data.obj_model_02[150].token_value;
        this.abdo_unary_nv = this.templates.data.obj_model_02[151].token_value;
        this.abdo_insert_n = this.templates.data.obj_model_02[152].token_value;
        this.abdo_insert_ab = this.templates.data.obj_model_02[153].token_value;
        this.abdo_insert_nv = this.templates.data.obj_model_02[154].token_value;
        this.abdo_vessel_n = this.templates.data.obj_model_02[155].token_value;
        this.abdo_vessel_ab = this.templates.data.obj_model_02[156].token_value;
        this.abdo_vessel_nv = this.templates.data.obj_model_02[157].token_value;
        this.spine1 = this.templates.data.obj_model_02[158].token_value;
        this.spine2 = this.templates.data.obj_model_02[159].token_value;
        this.spine3 = this.templates.data.obj_model_02[160].token_value;
        this.limbs_ra_n = this.templates.data.obj_model_02[161].token_value;
        this.limbs_ra_ab = this.templates.data.obj_model_02[162].token_value;
        this.limbs_ra_nv = this.templates.data.obj_model_02[163].token_value;
        this.limbs_rl_n = this.templates.data.obj_model_02[164].token_value;
        this.limbs_rl_ab = this.templates.data.obj_model_02[165].token_value;
        this.limbs_rl_nv = this.templates.data.obj_model_02[166].token_value;
        this.limbs_la_n = this.templates.data.obj_model_02[167].token_value;
        this.limbs_la_ab = this.templates.data.obj_model_02[168].token_value;
        this.limbs_la_nv = this.templates.data.obj_model_02[169].token_value;
        this.limbs_ll_n = this.templates.data.obj_model_02[170].token_value;
        this.limbs_ll_ab = this.templates.data.obj_model_02[171].token_value;
        this.limbs_ll_nv = this.templates.data.obj_model_02[172].token_value;
        this.gender2 = this.templates.data.obj_model_02[173].token_value;
        this.trimester = this.templates.data.trimester;
        this.no_of_fetuss = this.templates.data.no_of_fetus;
      }
    } else if (this.fetuses == 'C') {
      if (this.templates.data.trimester == 3) {
        this.ftsingle_id = this.templates.data.obj_model_01[74].token_value;
        this.patient_id = this.templates.data.obj_model_01[75].token_value;
        this.referance_id = this.templates.data.obj_model_01[76].token_value;
        this.author_id = this.templates.data.obj_model_01[77].token_value;
        this.branch_code = this.templates.data.obj_model_01[78].token_value;
        this.sex = this.templates.data.obj_model_01[92].token_value;
        this.lmp = this.templates.data.obj_model_01[80].token_value;
        this.ga = this.templates.data.obj_model_01[81].token_value;
        this.edd = this.templates.data.obj_model_01[82].token_value;
        this.no_of_fetus = this.templates.data.obj_model_01[83].token_value;
        this.tech_condition = this.templates.data.obj_model_01[84].token_value;
        this.fetal_heart_beat =
          this.templates.data.obj_model_01[84].token_value;
        this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
        this.crl = this.templates.data.obj_model_01[13].token_value;
        this.nt_thikness = this.templates.data.obj_model_01[14].token_value;
        this.amniotic_fluid = this.templates.data.obj_model_01[99].token_value;
        this.amnionicity = this.templates.data.obj_model_01[100].token_value;
        this.amniotic_fluids = this.templates.data.obj_model_01[99].token_value;
        this.p_location = this.templates.data.obj_model_01[98].token_value;
        this.us_average = this.templates.data.obj_model_01[93].token_value;
        this.uss_edd = this.templates.data.obj_model_01[94].token_value;
        this.us_edd = this.templates.data.obj_model_01[94].token_value;
        this.us_edds = this.templates.data.obj_model_01[94].token_value;
        this.genders = this.templates.data.obj_model_01[92].token_value;
        this.right_adnexium = this.templates.data.obj_model_01[24].token_value;
        this.left_adnexium = this.templates.data.obj_model_01[25].token_value;
        this.cervical_os = this.templates.data.obj_model_01[103].token_value;
        this.bpd = this.templates.data.obj_model_01[87].token_value;
        this.fl = this.templates.data.obj_model_01[88].token_value;
        this.ac = this.templates.data.obj_model_01[89].token_value;
        this.hc = this.templates.data.obj_model_01[90].token_value;
        this.efw = this.templates.data.obj_model_01[31].token_value;
        this.comments = this.templates.data.obj_model_01[104].token_value;
        this.ftimage = this.templates.data.obj_model_01[106].token_value;
        this.fin_year = this.templates.data.obj_model_01[107].token_value;
        this.entry_date = this.templates.data.obj_model_01[108].token_value;
        this.update_entry_date =
          this.templates.data.obj_model_01[109].token_value;
        this.presentation = this.templates.data.obj_model_01[85].token_value;
        this.fetus_lie = this.templates.data.obj_model_01[86].token_value;
        this.fet_weg = this.templates.data.obj_model_01[91].token_value;
        this.P_location_ana = this.templates.data.obj_model_01[97].token_value;
        this.fet = this.templates.data.obj_model_01[102].token_value;
        this.fetus = this.templates.data.obj_model_01[105].token_value;
        this.trimester = this.templates.data.trimester;
        this.no_of_fetuss = this.templates.data.no_of_fetus;
      } else if (this.templates.data.trimester == 2) {
        this.ftsingle_id = this.templates.data.obj_model_01[74].token_value;
        this.patient_id = this.templates.data.obj_model_01[75].token_value;
        this.referance_id = this.templates.data.obj_model_01[76].token_value;
        this.author_id = this.templates.data.obj_model_01[77].token_value;
        this.branch_code = this.templates.data.obj_model_01[78].token_value;
        this.sex = this.templates.data.obj_model_01[79].token_value;
        this.lmp = this.templates.data.obj_model_01[80].token_value;
        this.ga = this.templates.data.obj_model_01[81].token_value;
        this.edd = this.templates.data.obj_model_01[82].token_value;
        this.no_of_fetus = this.templates.data.obj_model_01[84].token_value;
        this.tech_condition = this.templates.data.obj_model_01[83].token_value;
        this.fetal_heart_beat =
          this.templates.data.obj_model_01[10].token_value;
        this.mean_gsd = this.templates.data.obj_model_01[12].token_value;
        this.crl = this.templates.data.obj_model_01[13].token_value;
        this.nt_thikness = this.templates.data.obj_model_01[14].token_value;
        this.amniotic_fluid = this.templates.data.obj_model_01[89].token_value;
        this.amnionicity = this.templates.data.obj_model_01[26].token_value;
        this.amniotic_fluids = this.templates.data.obj_model_01[89].token_value;
        this.p_location = this.templates.data.obj_model_01[86].token_value;
        this.us_average = this.templates.data.obj_model_01[19].token_value;
        this.uss_edd = this.templates.data.obj_model_01[20].token_value;
        this.us_edd = this.templates.data.obj_model_01[21].token_value;
        this.us_edds = this.templates.data.obj_model_01[22].token_value;
        this.genders = this.templates.data.obj_model_01[79].token_value;
        this.right_adnexium = this.templates.data.obj_model_01[24].token_value;
        this.left_adnexium = this.templates.data.obj_model_01[25].token_value;
        this.cervical_os = this.templates.data.obj_model_01[87].token_value;
        this.bpd = this.templates.data.obj_model_01[13].token_value;
        this.fl = this.templates.data.obj_model_01[14].token_value;
        this.ac = this.templates.data.obj_model_01[15].token_value;
        this.hc = this.templates.data.obj_model_01[16].token_value;
        this.efw = this.templates.data.obj_model_01[99].token_value;
        this.comments = this.templates.data.obj_model_01[101].token_value;
        this.ftimage = this.templates.data.obj_model_01[106].token_value;
        this.fin_year = this.templates.data.obj_model_01[107].token_value;
        this.entry_date = this.templates.data.obj_model_01[108].token_value;
        this.update_entry_date =
          this.templates.data.obj_model_01[109].token_value;
        this.presentation = this.templates.data.obj_model_01[11].token_value;
        this.fetus_lie = this.templates.data.obj_model_01[12].token_value;
        this.fet_weg = this.templates.data.obj_model_01[17].token_value;
        this.P_location_ana = this.templates.data.obj_model_01[23].token_value;
        this.fet = this.templates.data.obj_model_01[28].token_value;
        this.fetus = this.templates.data.obj_model_01[31].token_value;
        this.a_fluid = this.templates.data.obj_model_01[89].token_value;
        this.bd_mm = this.templates.data.obj_model_01[90].token_value;
        this.bd_ga = this.templates.data.obj_model_01[91].token_value;
        this.fdl_mm = this.templates.data.obj_model_01[92].token_value;
        this.fdl_ga = this.templates.data.obj_model_01[93].token_value;
        this.ac_mm = this.templates.data.obj_model_01[94].token_value;
        this.ac_ga = this.templates.data.obj_model_01[95].token_value;
        this.hc_mm = this.templates.data.obj_model_01[96].token_value;
        this.hc_ga = this.templates.data.obj_model_01[97].token_value;
        this.g_age = this.templates.data.obj_model_01[98].token_value;
        this.exdd = this.templates.data.obj_model_01[100].token_value;
        this.finding = this.templates.data.obj_model_01[101].token_value;
        this.chorionicity = this.templates.data.obj_model_01[85].token_value;
        this.fetal_mment = this.templates.data.obj_model_01[88].token_value;
        this.conclusion1 = this.templates.data.obj_model_01[102].token_value;
        this.conclusion2 = this.templates.data.obj_model_01[103].token_value;
        this.conclusion3 = this.templates.data.obj_model_01[104].token_value;

        this.head_shape_n = this.templates.data.obj_model_02[176].token_value;
        this.head_shape_ab = this.templates.data.obj_model_02[177].token_value;
        this.head_shape_nv = this.templates.data.obj_model_02[178].token_value;
        this.head_cavum_n = this.templates.data.obj_model_02[179].token_value;
        this.head_cavum_ab = this.templates.data.obj_model_02[180].token_value;
        this.head_cavum_nv = this.templates.data.obj_model_02[181].token_value;
        this.head_midline_n = this.templates.data.obj_model_02[182].token_value;
        this.head_midline_ab =
          this.templates.data.obj_model_02[183].token_value;
        this.head_midline_nv =
          this.templates.data.obj_model_02[184].token_value;
        this.head_thalami_n = this.templates.data.obj_model_02[185].token_value;
        this.head_thalami_ab =
          this.templates.data.obj_model_02[186].token_value;
        this.head_thalami_nv =
          this.templates.data.obj_model_02[187].token_value;
        this.head_lateral_n = this.templates.data.obj_model_02[188].token_value;
        this.head_lateral_ab =
          this.templates.data.obj_model_02[189].token_value;
        this.head_lateral_nv =
          this.templates.data.obj_model_02[190].token_value;
        this.head_cere_n = this.templates.data.obj_model_02[191].token_value;
        this.head_cere_ab = this.templates.data.obj_model_02[192].token_value;
        this.head_cere_nv = this.templates.data.obj_model_02[193].token_value;
        this.face_upp_n = this.templates.data.obj_model_02[194].token_value;
        this.face_upp_ab = this.templates.data.obj_model_02[195].token_value;
        this.face_upp_nv = this.templates.data.obj_model_02[196].token_value;
        this.face_orbit_n = this.templates.data.obj_model_02[197].token_value;
        this.face_orbit_ab = this.templates.data.obj_model_02[198].token_value;
        this.face_orbit_nv = this.templates.data.obj_model_02[199].token_value;
        this.face_nose_n = this.templates.data.obj_model_02[200].token_value;
        this.face_nose_ab = this.templates.data.obj_model_02[201].token_value;
        this.face_nose_nv = this.templates.data.obj_model_02[202].token_value;
        this.neck1 = this.templates.data.obj_model_02[203].token_value;
        this.neck2 = this.templates.data.obj_model_02[204].token_value;
        this.neck3 = this.templates.data.obj_model_02[205].token_value;
        this.tho_shape_n = this.templates.data.obj_model_02[206].token_value;
        this.tho_shape_ab = this.templates.data.obj_model_02[207].token_value;
        this.tho_shape_nv = this.templates.data.obj_model_02[208].token_value;
        this.tho_mass_n = this.templates.data.obj_model_02[209].token_value;
        this.tho_mass_ab = this.templates.data.obj_model_02[210].token_value;
        this.tho_mass_nv = this.templates.data.obj_model_02[211].token_value;
        this.heart_activity_n =
          this.templates.data.obj_model_02[212].token_value;
        this.heart_activity_ab =
          this.templates.data.obj_model_02[213].token_value;
        this.heart_activity_nv =
          this.templates.data.obj_model_02[214].token_value;
        this.heart_size_n = this.templates.data.obj_model_02[215].token_value;
        this.heart_size_ab = this.templates.data.obj_model_02[216].token_value;
        this.heart_size_nv = this.templates.data.obj_model_02[217].token_value;
        this.heart_cadic_n = this.templates.data.obj_model_02[218].token_value;
        this.heart_cadic_ab = this.templates.data.obj_model_02[219].token_value;
        this.heart_cadic_nv = this.templates.data.obj_model_02[220].token_value;
        this.heart_chamber_n =
          this.templates.data.obj_model_02[221].token_value;
        this.heart_chamber_ab =
          this.templates.data.obj_model_02[222].token_value;
        this.heart_chamber_nv =
          this.templates.data.obj_model_02[223].token_value;
        this.abdo_dia_n = this.templates.data.obj_model_02[224].token_value;
        this.abdo_dia_ab = this.templates.data.obj_model_02[225].token_value;
        this.abdo_dia_nv = this.templates.data.obj_model_02[226].token_value;
        this.abdo_sto_n = this.templates.data.obj_model_02[227].token_value;
        this.abdo_sto_ab = this.templates.data.obj_model_02[228].token_value;
        this.abdo_sto_nv = this.templates.data.obj_model_02[229].token_value;
        this.abdo_bowel_n = this.templates.data.obj_model_02[230].token_value;
        this.abdo_bowel_ab = this.templates.data.obj_model_02[231].token_value;
        this.abdo_bowel_nv = this.templates.data.obj_model_02[232].token_value;
        this.abdo_kidney_n = this.templates.data.obj_model_02[233].token_value;
        this.abdo_kidney_ab = this.templates.data.obj_model_02[234].token_value;
        this.abdo_kidney_nv = this.templates.data.obj_model_02[235].token_value;
        this.abdo_unary_n = this.templates.data.obj_model_02[236].token_value;
        this.abdo_unary_ab = this.templates.data.obj_model_02[237].token_value;
        this.abdo_unary_nv = this.templates.data.obj_model_02[238].token_value;
        this.abdo_insert_n = this.templates.data.obj_model_02[239].token_value;
        this.abdo_insert_ab = this.templates.data.obj_model_02[240].token_value;
        this.abdo_insert_nv = this.templates.data.obj_model_02[241].token_value;
        this.abdo_vessel_n = this.templates.data.obj_model_02[242].token_value;
        this.abdo_vessel_ab = this.templates.data.obj_model_02[243].token_value;
        this.abdo_vessel_nv = this.templates.data.obj_model_02[244].token_value;
        this.spine1 = this.templates.data.obj_model_02[245].token_value;
        this.spine2 = this.templates.data.obj_model_02[246].token_value;
        this.spine3 = this.templates.data.obj_model_02[247].token_value;
        this.limbs_ra_n = this.templates.data.obj_model_02[248].token_value;
        this.limbs_ra_ab = this.templates.data.obj_model_02[249].token_value;
        this.limbs_ra_nv = this.templates.data.obj_model_02[250].token_value;
        this.limbs_rl_n = this.templates.data.obj_model_02[251].token_value;
        this.limbs_rl_ab = this.templates.data.obj_model_02[252].token_value;
        this.limbs_rl_nv = this.templates.data.obj_model_02[253].token_value;
        this.limbs_la_n = this.templates.data.obj_model_02[254].token_value;
        this.limbs_la_ab = this.templates.data.obj_model_02[255].token_value;
        this.limbs_la_nv = this.templates.data.obj_model_02[256].token_value;
        this.limbs_ll_n = this.templates.data.obj_model_02[257].token_value;
        this.limbs_ll_ab = this.templates.data.obj_model_02[258].token_value;
        this.limbs_ll_nv = this.templates.data.obj_model_02[259].token_value;
        this.gender2 = this.templates.data.obj_model_02[260].token_value;
        this.trimester = this.templates.data.trimester;
        this.no_of_fetuss = this.templates.data.no_of_fetus;
      }
    }
  }

  reload() {
    this.resload = true;
    this.obs.refreshResult(this.patient.result_id).subscribe(
      (resSuccess: any) => {
        this.resload = false;
        console.log(resSuccess);

        if (resSuccess.Name == 'Updated Successfully') {
          this._snackBar.open('Result Rebuilt Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this._snackBar.open('Error Try Again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.buildLoad = false;
        this._snackBar.open('Error Building Result', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }

  onSubmit(e) {
    // e.preventDefault();
    this.stateForm.patchValue({
      formatstr: this.htmlStr.replace(/"/g, "'"),
    });
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultTemplate(sample_id, format_code, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          // this.getResult()
          this.stateForm.reset();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          console.log('error');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  printResult(): void {
    let printContents, popupWin;
    printContents = document.getElementById('result').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #receipt {
            width: 500px;
            margin-left: 100px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
}
